import { InfoIconModule } from '../info-icon/info-icon.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { FiCheckboxModule } from '@fi-shared/checkbox';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiCheckboxListModule } from '@fi-shared/checkbox-list';
import { FiObjectsSelectorComponentModule } from '@fi-shared/objects-selector';
import { AccessRightFiltersComponent } from './access-right-filters.component';
import { FiCheckbox2Module } from '@fi-shared/fi-checkbox2/fi-checkbox2.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { AccessRightFiltersQuickSelectionComponent } from './access-right-filters-quick-selection/access-right-filters-quick-selection.component';
import { AccessRightFiltersManualSelectionComponent } from './access-right-filters-manual-selection/access-right-filters-manual-selection.component';
import { AccessRightFiltersTabsComponent } from './access-right-filters-tabs/access-right-filters-tabs.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiAccessRightsManualSelectionAreaComponent } from './access-right-filters-manual-selection/fi-access-rights-manual-selection-area/fi-access-rights-manual-selection-area.component';
import { FiAccessRightsManualSelectionBusinessAreaComponent } from './access-right-filters-manual-selection/fi-access-rights-manual-selection-business-area/fi-access-rights-manual-selection-business-area.component';
import { FiAccessRightsManualSelectionRolesComponent } from './access-right-filters-manual-selection/fi-access-rights-manual-selection-roles/fi-access-rights-manual-selection-roles.component';
import { FiManualSharingSelectionInfoContainerModule } from '@fi-shared/fi-manual-sharing-selection-info-container/fi-manual-sharing-selection-info-container.module';
import { FiQuickSelectionSectionComponent } from './fi-quick-selection-section/fi-quick-selection-section.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiManualSelectionSectionComponent } from './fi-manual-selection-section/fi-manual-selection-section.component';
import { FiIndividualUnitsSectionComponent } from './fi-individual-units-section/fi-individual-units-section.component';
import { FiRolesSelectSearchComponent } from './fi-roles-select-search/fi-roles-select-search.component';
import { FiSharingSettingsContentComponent } from './fi-sharing-settings-content/fi-sharing-settings-content.component';
import { SharingSettingsHelperService } from './fi-sharing-settings-content/sharing-settings-helper.service';
import { FiTooltipModule } from '../fi-tooltip/fi-tooltip.module';
import { FiItemSharingSettingsDialogComponent } from './fi-item-sharing-settings-dialog/sharing-settings-dialog.component';
import { FiSharingSettingsComponent } from './fi-item-sharing-settings-dialog/sharing-settings/sharing-settings.component';
import { MatRadioModule } from '@angular/material/radio';
import { FiItemSharingSettingsDialogService } from './fi-item-sharing-settings-dialog/fi-item-sharing-settings.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        FiCheckboxModule,
        FiCheckbox2Module,
        FiAppTextSharedModule,
        FiErrorMessageModule,
        FiCheckboxListModule,
        FiObjectsSelectorComponentModule,
        InfoIconModule,
        SelectSearchModule,
        MatInputModule,
        MatFormFieldModule,
        MatCheckboxModule,
        FiLoadingModule,
        FiManualSharingSelectionInfoContainerModule,
        MatDividerModule,
        FiTooltipModule,
        MatRadioModule,
    ],
    declarations: [
        AccessRightFiltersComponent,
        AccessRightFiltersQuickSelectionComponent,
        AccessRightFiltersManualSelectionComponent,
        AccessRightFiltersTabsComponent,
        FiAccessRightsManualSelectionAreaComponent,
        FiAccessRightsManualSelectionBusinessAreaComponent,
        FiAccessRightsManualSelectionRolesComponent,
        FiQuickSelectionSectionComponent,
        FiManualSelectionSectionComponent,
        FiIndividualUnitsSectionComponent,
        FiRolesSelectSearchComponent,
        FiSharingSettingsContentComponent,
        FiItemSharingSettingsDialogComponent,
        FiSharingSettingsComponent,
    ],
    exports: [
        AccessRightFiltersComponent,
        FiAccessRightsManualSelectionAreaComponent,
        FiAccessRightsManualSelectionBusinessAreaComponent,
        FiAccessRightsManualSelectionRolesComponent,
        AccessRightFiltersQuickSelectionComponent,
        FiQuickSelectionSectionComponent,
        FiManualSelectionSectionComponent,
        FiIndividualUnitsSectionComponent,
        FiRolesSelectSearchComponent,
        FiSharingSettingsContentComponent,
        FiItemSharingSettingsDialogComponent,
        FiSharingSettingsComponent,
    ],
    providers: [SharingSettingsHelperService, FiItemSharingSettingsDialogService],
})
export class FiAccessRightFiltersModule {}
